import store from '@/store';

export default class LGKeyStorage {
  static get(name) {
    try {
      //const value = tizen.keymanager.getData({ name });
      return value;
    } catch (error) {
      console.log(
        `Couldn't find ${name} in storage, because of Error: ${error.name} with Error Message: ${error.message}`
      );
      return undefined;
    }
  }

  static save(name, value) {
    return new Promise((resolve) => {
      const callback = (context) => {
        resolve();
      };
      try {
        this.remove(name);
        //tizen.keymanager.saveData(name, value, null, callback, callback);
      } catch (error) {
        store.dispatch('notification/new', {
          title: 'Save data ' + name,
          message: value,
        });
      }
    });
  }
  
  static remove(name) {
    try {
      //tizen.keymanager.removeData({ name });
    } catch (error) {
      console.log('Could not remove by name: ', name, error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/StorageHandler/LG.js